import { Table2 } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '~/components/ui/Accordion';

export interface CatalogueTable {
  name: string;
  keyFields: string[];
  totalFields: number;
  note?: string;
  description?: string;
}

interface ConnectorDataCatalogueProps {
  catalogue: CatalogueTable[];
}

export default function ConnectorDataCatalogue({
  catalogue,
}: ConnectorDataCatalogueProps) {
  return (
    <div className="pl-2 lg:pl-11">
      <Accordion type="single" collapsible className="w-full">
        {catalogue.map((table, index) => (
          <AccordionItem
            key={index}
            value={`table-${index}`}
            className="border-b last:border-0"
          >
            <AccordionTrigger className="hover:no-underline py-3">
              <div className="flex items-center gap-3 text-left">
                <div className="size-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <Table2 className="size-4 text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold text-sm">{table.name}</h4>
                  {table.description && (
                    <p className="text-xs text-muted-foreground font-normal">
                      {table.description}
                    </p>
                  )}
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="pl-4 lg:pl-11 space-y-3">
                {table.note && (
                  <div className="p-3 bg-muted/50 rounded-md border">
                    <p className="text-xs text-muted-foreground italic leading-relaxed">
                      {table.note}
                    </p>
                  </div>
                )}
                <div>
                  <h5 className="text-sm font-medium mb-2">
                    Key Fields ({table.keyFields.length} of {table.totalFields})
                  </h5>
                  <div className="grid grid-cols-2 gap-2">
                    {table.keyFields.slice(0, 8).map((field, fieldIndex) => (
                      <div
                        key={fieldIndex}
                        className="px-2.5 py-2 bg-accent/50 rounded border border-border/50 truncate text-center text-xs lg:text-sm max-w-full lg:max-w-none lg:text-left text-wrap break-words lg:break-words"
                      >
                        <code className="text-xs font-mono text-foreground">
                          {field}
                        </code>
                      </div>
                    ))}
                  </div>
                  {table.keyFields.length > 8 && (
                    <p className="text-xs text-muted-foreground mt-2">
                      + {table.keyFields.length - 8} more fields
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1.5">
                    <div className="size-2 rounded-full bg-green-500" />
                    Auto-synced
                  </span>
                  <span>•</span>
                  <span>{table.totalFields} fields</span>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
